import { Google, Pixall, PixallTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities/index.js';

export function snap360Click(metadata = {}, option) {

    const { dataLayer, state, data = {} } = metadata;
    const { inventoryId } = data;

    const inventory = getInventoryOwnerById(state, inventoryId);
    const { specifications, listingType } = inventory;
    const fuelEconomy = specifications?.mpg?.value;

    const clickType = state?.query?.clickType || '';
    const eventLabel = 'cta::snap-360';
    const brandName = dataLayer.brand?.toUpperCase();
    const feature = brandName === 'ATC' ? 'Snap 360' : 'VI360';

    Google.sendClickEvent({
        eventElement: `vdp_${listingType.toLowerCase()}`,
        eventResult: eventLabel,
    }, option);

    Pixall.sendClickEvent({
        assistChannel: brandName,
        assistProduct: dataLayer.page?.pageName.toUpperCase(),
        assistSubchannel: 'VI360',
        feature,
        eventSource: 'vehicle',
        label: eventLabel,
        listingType: PixallTransformers.listingTypeUtils.convertClickTypeToListingType(clickType),
        vehicleType: listingType.toUpperCase(),
        pageType: 'vdp',
        fuelEconomy,
        ...data,
        inventory,
        cdl: {
            eventProperties: {
                action: 'Click',
                element: 'Snap VI360 Click',
                tagIndex: 'vdp-023',
            },
        },
    }, dataLayer, option);

    return {};
}

/**
 * @summary Sends Snap VI 360 - Click
 */
export function vi360Click(metadata = {}, option) {

    const { dataLayer, state, data = {} } = metadata;
    const { inventoryId } = data;

    const inventory = getInventoryOwnerById(state, inventoryId);

    const eventLabel = 'cta::vi360';
    const feature = 'VI360';
    const brandName = dataLayer.brand?.toUpperCase();

    Pixall.sendClickEvent({
        assistChannel: brandName === 'ATC' ? 'Autotrader' : brandName,
        assistProduct: dataLayer.page?.pageName.toUpperCase(),
        assistSubchannel: feature,
        feature,
        eventSource: 'vehicle',
        label: eventLabel,
        pixallData: {
            clickTypeToListingType: true,
        },
        ...data,
        inventory,
        cdl: {
            eventProperties: {
                action: 'Click',
                element: 'VI360 Click',
                tagIndex: 'vdp-022',
            },
        },
    }, dataLayer, option);

    return {};
}
